/* eslint-disable semi */
'use strict';

// importer gsap et animations
import { gsap } from 'gsap';
import { image } from './jeu';
import { slider, addBackdrop } from './tutoriel';

// dialogues partie apprendre
const dialogueLearn = ['1.mp3', '2.mp3', '3.mp3', '4.mp3', '5.mp3', '6.mp3'];
let dialogueLearnIndex = -1;
const dialogsLearnAudio = document.querySelector('.dialogs--learn');

// dialogues partie histoire
const dialogueStory = ['8.mp3', '9.mp3', '10.mp3', '11.mp3', '12.mp3'];
let dialogueStoryIndex = -1;
const dialogsStoryAudio = document.querySelector('.dialogs--story');

function playDialog (audioType, callback) {
  btnPrev.classList.remove('btn--hidden');

  if (callback) {
    callback();
  }

  switch (audioType) {
    case 'learn':
      dialogsLearnAudio.src = 'assets/dialogues/' + dialogueLearn[dialogueLearnIndex];
      dialogsLearnAudio.play();
      break;

    case 'story':
      dialogsStoryAudio.src = 'assets/dialogues-histoire/' + dialogueStory[dialogueStoryIndex];
      dialogsStoryAudio.play();
      break;

    default:
      break;
  }
}

const alreadyPlayed = document.querySelector('.dejajouer');
const persoEcoloClickAlreadyPlayed = document.querySelector('.dejajouer--click');
const dialogAlreadyPlayed = document.querySelector('.dialogs--played');
const sectionFirst = document.querySelector('.section--first');
const sectionSecond = document.querySelector('.section--second');

if (alreadyPlayed) {
  sectionSecond.classList.add('btn--hidden');
  persoEcoloClickAlreadyPlayed.addEventListener('click', hide);
}

// recuperation prenom
const formulaire = document.querySelector('.form');
const rate = document.querySelector('.rate');
const reussi = document.querySelector('.reussi');
const submit = document.querySelector('.button--submit');
const sound = document.querySelector('.button--sound');
const musicBody = new Audio('https://aurelie-louage.be/projets/tfe/assets/musique/musique4.mp3');
const sectionSuccess = document.querySelector('.section--reussi');
const sectionFailed = document.querySelector('.section--rate');
const nameElement = document.querySelector('.perso');
const jauges = document.querySelector('.boutons--jauge');
const jaugeD = document.querySelector('.jauge--detritus');

const playMusicBody = () => {
  musicBody.play();
  musicBody.loop = true;
  musicBody.volume = 0.5;
}

if (reussi) {
  sectionSuccess.classList.remove('btn--hidden');
  const tl = gsap.timeline();
  tl.from('.perso--ecolo05', { opacity: 0, right: '-300px', duration: 0.7 });
  tl.to('.perso--ecolo05', { opacity: 1 });
  tl.from('.bulle', { opacity: 0, scale: 0.7, duration: 0.3 });
  tl.to('.bulle', { opacity: 0 }, '+=4');
  tl.to('.perso--ecolo05', { opacity: 1, right: '-300px', display: 'none', duration: 0.7 }, '+=0.1');

  if (window.matchMedia('(min-width:767px)').matches) {
    sectionSuccess.classList.add('btn--hidden');
  }
}
if (rate) {
  sectionFailed.classList.remove('btn--hidden');
  const tl = gsap.timeline();
  tl.from('.perso--detritus01', { opacity: 0, right: '-300px', duration: 0.7 });
  tl.to('.perso--detritus01', { opacity: 1 });
  tl.from('.bulle', { opacity: 0, scale: 0.7, duration: 0.3 });
  tl.to('.bulle', { opacity: 0 }, '+=4');
  tl.to('.perso--detritus01', { opacity: 1, right: '-300px', display: 'none', duration: 0.7 }, '+=0.1');

  if (window.matchMedia('(min-width:767px)').matches) {
    sectionFailed.classList.add('btn--hidden');
  }
}

if ((rate) || (reussi)) {
  const localName = localStorage.getItem('userName');
  nameElement.innerHTML = localName;

  musicBody.pause()
  sound.classList.add('btn--hidden');
  const list = document.querySelector('.resultats__list');
  const body = document.querySelector('body');
  body.style.overflow = 'inherit';
  body.style.height = 'inherit';
  body.style.background = 'url(./assets/images/backk@2x.png)';
  body.style.backgroundSize = 'cover';
  const html = document.querySelector('html');
  html.style.overflow = 'inherit';
  jauges.style.width = '45%';
  jauges.style.marginRight = 'auto';

  const tl = gsap.timeline()
  tl.to('.jauges', { opacity: 1, scale: 1.2, duration: 0.4 });
  tl.to('.jauges', { scale: 1, duration: 0.4 });

  const results = JSON.parse(localStorage.getItem('results'));

  results.forEach((item) => {
    const li = document.createElement('li');
    const p = document.createElement('p');
    p.innerHTML = item.nom;
    li.classList.add('resultats__list--el');
    li.classList.add(item.result ? 'color--green' : 'color--red');
    li.innerHTML = `
    <ul>
      <li><img src="${item.img}" alt="image de l'objet trié" class="img--obj"></li>
      <li><img src="./assets/images/fleche.svg" alt="flèche" class="img--fleche"></li>
      <li><img src="${item.imgreponse}" alt="image de la réponse" class="img--reponse"></li>
    </ul>
    `
    list.appendChild(p);
    list.appendChild(li);
  })

  const jaugeCount = results.reduce((acc, item) => {
    if (item.result === true) {
      acc.win++;
    } else {
      acc.fail++;
    }
    return acc;
  }, { win: 0, fail: 0 });

  const jaugeE = document.querySelector('.jauge--ecolo');
  const ecoloElements = jaugeE.querySelectorAll('.jauge--ecoloEl');
  const detritusElements = jaugeD.querySelectorAll('.jauge--detritusEl');

  for (let index = 0; index < jaugeCount.win; index++) {
    const tl0 = gsap.timeline();
    tl0.to(ecoloElements[index], { fill: '#1C8434', duration: 0.3 });
    tl0.to(ecoloElements[index], { fill: '#ddd3d7', duration: 0.3 });
    tl0.to(ecoloElements[index], { fill: '#1C8434', duration: 0.3 });
    tl0.to(jaugeE, { scale: 1, y: 0, x: 0, duration: 0.8 });
  }

  for (let index = 0; index < jaugeCount.fail; index++) {
    const tl0 = gsap.timeline();
    tl0.to(detritusElements[index], { fill: '#843535', duration: 0.3 });
    tl0.to(detritusElements[index], { fill: '#ddd3d7', duration: 0.3 });
    tl0.to(detritusElements[index], { fill: '#843535', duration: 0.3 });
  }

  localStorage.setItem('results', JSON.stringify([]));
}

if (formulaire) {
  submit.addEventListener('click', (e) => {
    const name = document.querySelector('.nom').value;
    localStorage.setItem('userName', name);
    const city = document.querySelector('.select').value;
    localStorage.setItem('city', city);
  })
}

// animations sur page d'accueil
const accueil = document.querySelector('.section--accueil');
const btnJouer = document.querySelector('.button--landing');
const btnCommencer = document.querySelector('.button--jouer');
const illus = document.querySelector('.illus');
const btnChoix = document.querySelector('.button--choix');

if (illus) {
  const tl = gsap.timeline()
  tl.from('.logo', { opacity: 0 });
  tl.to('.logo', { opacity: 1, duration: 0.5 });
  tl.from('.button--one', { scaleX: 1.2, scaleY: 1.2, opacity: 0 });
  tl.to('.button--one', { scaleX: 1, scaleY: 1, opacity: 1, duration: 0.3 }, '-=0.4');
  tl.from('.button--two', { scaleX: 1.2, scaleY: 1.2, opacity: 0 });
  tl.to('.button--two', { scaleX: 1, scaleY: 1, duration: 0.3, delay: 0.2 });
}

if ((btnCommencer) || (btnChoix) || (formulaire)) {
  sound.classList.add('btn--hidden');
}

// son on-off header
const activeMode = localStorage.getItem('sound2-mode');
if (activeMode === 'on') {
  document.body.setAttribute('sound2-mode', 'on');
}
sound.addEventListener('click', function (e) {
  if (document.body.getAttribute('sound2-mode', 'on')) {
    localStorage.setItem('sound2-mode', 'off');
    document.body.removeAttribute('sound2-mode', '');
    musicBody.pause();
  } else {
    document.body.setAttribute('sound2-mode', 'on');
    localStorage.setItem('sound2-mode', 'on');
    playMusicBody();
  }
})

const buttonLanding = document.querySelector('.button--landing');
if (buttonLanding) {
  sound.classList.add('btn--hidden');
}

if (accueil) {
  const tl = gsap.timeline();
  tl.from('.illu--ecolo1', { opacity: 0, y: 100, duration: 0.3 });
  tl.from('.illu--detritus1', { opacity: 0, y: 100, duration: 0.3 });
  tl.to('.illu--ecolo1', { opacity: 1, y: 0, duration: 0.8 }, '+=0.6');
  tl.to('.illu--detritus1', { opacity: 1, y: 0, duration: 0.8 }, '+=0.6');
}

// selectionner navigation
const btnPrev = document.querySelector('.nav__list--prev');
const btnNext = document.querySelector('.nav__list--after');
const number = document.getElementById('number');
const slider2 = document.querySelector('.slider2');
const nav = document.querySelector('.nav__list');
const persoEcoloClickTuto = document.querySelector('.tuto--click');
const persoEcoloClickStory = document.querySelector('.story--click');
const header = document.querySelector('.header');
const nombre = document.querySelector('.nav__list--number');
const body = document.body;

let nb = 0;
const nf = 6;

if (slider) {
  btnNext.addEventListener('click', next);
  btnPrev.addEventListener('click', prev);

  if ((slider) && (nb === 0)) {
    btnPrev.classList.add('btn--hidden');
    nav.classList.add('btn--hidden');
    persoEcoloClickTuto.addEventListener('click', (e) => {
      next();
    });
    dialogAnimation();
  }

  addBackdrop();
}

if (slider2) {
  btnNext.addEventListener('click', next);
  btnPrev.addEventListener('click', prev);

  if ((slider2) && (nb === 0)) {
    nav.classList.add('btn--hidden');
    persoEcoloClickStory.addEventListener('click', (e) => {
      next();
      btnPrev.classList.add('btn--hidden');
    });
    dialogAnimation();
  }

  nombre.style.color = '#1b1c1b';
}

// aller vers la page suivante
function next () {
  const elShow = document.querySelector('.slider__el--show');
  const elNext = elShow.nextElementSibling;

  elShow.classList.remove('slider__el--show');

  if (elNext) {
    nav.classList.remove('btn--hidden');
    elNext.classList.add('slider__el--show');
    if (nb <= nf) {
      nb++;
      number.innerHTML = nb;
    }
    if (slider) {
      playDialog('learn', () => { dialogueLearnIndex++ });
    }
    if (slider2) {
      playDialog('story', () => { dialogueStoryIndex++ });
    }
    if ((slider) && (nb === 1)) {
      btnPrev.classList.add('btn--hidden');
    }
    if ((slider2) && (nb === 2)) {
      const tl14 = gsap.timeline();
      tl14.from('.img--detritus', { opacity: 0, x: 100, y: -100, duration: 0.5 });
      tl14.to('.img--detritus', { opacity: 1, x: 0, y: 0, duration: 0.5 });
      tl14.from('.bulle', { opacity: 0, scale: 0.7, duration: 0.3 });
      tl14.to('.bulle', { opacity: 1, scale: 1, duration: 0.3 }, '+=0.6');
    }
    if ((slider2) && (nb > 2)) {
      dialogAnimation();
    }
    if ((slider2) && (nb === 5)) {
      nav.classList.add('btn--hidden');
    }
    if ((slider) && (nb === 6)) {
      nav.classList.add('btn--hidden');
      header.classList.remove('btn--hidden');
      body.classList.remove('backdrop');
      const tl12 = gsap.timeline();
      tl12.to('.perso--ecolo04', { bottom: '50px', duration: 0.4 });
    }
    if ((slider) && (nb <= 7)) {
      dialogAnimation();
    }
  } else {
    const elFirst = elShow.parentNode.firstElementChild;
    elFirst.classList.add('slider__el--show');
  }
}

// retourner en arrière
function prev () {
  const elShow = document.querySelector('.slider__el--show');
  const elPrev = elShow.previousElementSibling;

  elShow.classList.remove('slider__el--show');

  if (elPrev) {
    elPrev.classList.add('slider__el--show');
    if (nb <= nf && nb > 1) {
      nb--;
      number.innerHTML = nb;
    }
    if (slider) {
      playDialog('learn', () => { dialogueLearnIndex-- });
    }
    if (slider2) {
      playDialog('story', () => { dialogueStoryIndex-- });
    }
    if ((slider) && (nb === 1)) {
      btnPrev.classList.add('btn--hidden');
    }
    if ((slider2) && (nb === 1)) {
      btnPrev.classList.add('btn--hidden');
      dialogAnimation();
    }
    if ((slider) && (nb <= 6)) {
      dialogAnimation();
    }
    if ((slider) && (nb === 6)) {
      nav.classList.add('btn--hidden');
      header.classList.remove('btn--hidden');
      const tl12 = gsap.timeline();
      tl12.to('.perso--ecolo04', { bottom: '50px', duration: 0.4 });
    }
    if ((slider2) && (nb > 2)) {
      dialogAnimation();
    }
    if ((slider2) && (nb === 2)) {
      const tl14 = gsap.timeline();
      tl14.from('.img--detritus', { opacity: 0, x: 100, y: -100, duration: 0.5 });
      tl14.to('.img--detritus', { opacity: 1, x: 0, y: 0, duration: 0.5 });
      tl14.from('.bulle', { opacity: 0, scale: 0.7, duration: 0.3 });
      tl14.to('.bulle', { opacity: 1, scale: 1, duration: 0.3 }, '+=0.6');
    }
  } else {
    const elLast = elShow.parentNode.lastElementChild;
    elLast.classList.add('slider__el--show');
  }
}

// afficher message si affiché sur desktop au delà de 1000px
const paragraph = document.querySelector('.paragraph');
const landingPage = document.querySelector('.body--landing');

if ((window.matchMedia('(min-width: 1025px)').matches) && (landingPage)) {
  paragraph.innerHTML = 'Le jeu fonctionne uniquement sur un smarpthone ou une tablette en mode portrait.';
  paragraph.style.width = '90%';
  btnJouer.classList.add('btn--hidden');
}

// changer background si landing page
if (landingPage) {
  landingPage.style.backgroundImage = "url('http://aurelie-louage.be/projets/tfe/assets/images/back.png')";
  landingPage.style.backgroundSize = 'cover';

  if (window.devicePixelRatio === 2) {
    landingPage.style.backgroundImage = "url('http://aurelie-louage.be/projets/tfe/assets/images/back@2x.png')";
  }

  if (window.matchMedia('(min-width:701px) and (max-width:1025px)').matches) {
    landingPage.style.backgroundImage = "url('http://aurelie-louage.be/projets/tfe/assets/images/back-tablet.png')";

    if (window.devicePixelRatio === 2) {
      landingPage.style.backgroundImage = "url('http://aurelie-louage.be/projets/tfe/assets/images/back-tablet@2x.png')";
      landingPage.style.backgroundSize = 'cover';
    }
  }

  if (window.matchMedia('(min-width:300px) and (max-width:700px)').matches) {
    landingPage.style.backgroundImage = "url('http://aurelie-louage.be/projets/tfe/assets/images/back-smart.png')";

    if (window.devicePixelRatio === 2) {
      landingPage.style.backgroundImage = "url('http://aurelie-louage.be/projets/tfe/assets/images/back-smart@2x.png')";
    }
  }
}

// changer top des blocks si c'est sur le jeu
const jeu = document.querySelector('.section--jeu');
const blocks = document.querySelector('.block');
const imageJeu = document.querySelector('.image');
if (window.matchMedia('(max-width: 359px)').matches) {
  if (jeu) {
    blocks.style.top = '100px';
    imageJeu.style.height = '115px';
    imageJeu.style.width = '115px';
    imageJeu.style.position = 'absolute';
    image.style.left = '8%';
  }
}

// date en js quand il y a le footer
const date = new Date().getFullYear();
const footer = document.querySelector('.footer');
if (footer) {
  document.getElementById('annee').innerHTML = date;
}

// functions
function dialogAnimation () {
  const tl11 = gsap.timeline();
  tl11.from('.bulle', { opacity: 0, scale: 0.7, duration: 0.3 });
  tl11.to('.bulle', { opacity: 1, scale: 1, duration: 0.3 }, '+=0.6');
}

function hide () {
  sectionFirst.classList.add('btn--hidden');
  sectionSecond.classList.remove('btn--hidden');
  dialogAlreadyPlayed.play();
}
